import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
import DisplayIf from 'shared/DisplayIf.jsx';
Number.prototype.formatCurrency = formatCurrency;

const VirtualEventItem = ({
  id,
  name,
  quantity,
  price,
  qtyNotEditable,
  onRemoveVirtualEvent,
  onQuantityChange
}) => (
  <div className="list-group-item-labeled">
    <div
      style={{width: 120}}
      className="list-group-item-labeled-child"
    >
      <span>{'Virtual Event'}</span>
      <span>{name}</span>
    </div>

    <div
      style={{width: 150}}
      className="list-group-item-labeled-child"
    />

    <div
      style={{width: 80}}
      className="list-group-item-labeled-child"
    />

    <div
      style={{width: 80}}
      className="list-group-item-labeled-child"
    >
      <span>{'Quantity'}</span>
      <input
        style={{width: 80}}
        disabled={qtyNotEditable}
        value={quantity}
        type="number"
        min="0"
        step="1"
        onChange={event => onQuantityChange({
          virtualEventId: id,
          inputValue: event.target.value
        })} />
    </div>

    <div
      className="list-group-item-labeled-child"
      style={{width: 80}}
    >
      <span>{'Unit Price ($)'}</span>
      <span>{price.formatCurrency(2)}</span>
    </div>

    <div
      className="list-group-item-labeled-child"
      style={{width: 80}}
    >
      <span>{'Item Total ($)'}</span>
      <span>{(price*quantity).formatCurrency(2)}</span>
    </div>
    <DisplayIf condition={!qtyNotEditable}>
    <div
      style={{width: 80}}
      className="list-group-item-labeled-child"
    >
      <button
        className="btn btn-link"
        type="button"
        onClick={() => onRemoveVirtualEvent(id)}
      ><i className="fa fa-shopping-cart" /> {'Remove'}</button>
    </div>
</DisplayIf>
  </div>
);

VirtualEventItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  quantity: PropTypes.number,
  price: PropTypes.number,
  qtyNotEditable: PropTypes.bool,
  onRemoveVirtualEvent: PropTypes.func,
  onQuantityChange: PropTypes.func
};

VirtualEventItem.defaultProps = {
  price: 0,
  quantity: 0
};

export default VirtualEventItem;



// WEBPACK FOOTER //
// ./src/features/shared/VirtualEventItem.jsx